export const makeAction = (type) => {
    return (payload) => ({
        type,
        payload,
    });
};

export const success = actionName => `${actionName}_SUCCESS`;

export const fail = actionName => `${actionName}_FAIL`;



// WEBPACK FOOTER //
// /src/redux/actions/makeAction.js